module.exports = __webpack_public_path__ + "media/images/flags/1x1/ven-0ed2025c0acdee4c8c559d122e3308aa.svg";